import type React from 'react'

type Props = {
  size?: number
  fill?: boolean
}

export const IconCollapse: React.FC<Props> = ({ size = 12, fill }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="6.5"
      cy="6"
      r="5.5"
      {...(fill && { fill: 'var(--icon-circle-color)' })}
      stroke="var(--icon-circle-color)"
    />
    <path
      d="M9.74541 6.70719C9.9111 6.87288 9.9111 7.14151 9.74541 7.3072L9.41516 7.63745C9.24947 7.80314 8.98083 7.80314 8.81514 7.63745L6.50002 5.36479L4.18489 7.63744C4.0192 7.80313 3.75056 7.80313 3.58487 7.63744L3.25461 7.30718C3.08892 7.14149 3.08892 6.87286 3.25461 6.70717L6.19992 3.76187C6.28602 3.67576 6.39993 3.63441 6.51274 3.63779C6.61708 3.64088 6.72049 3.68224 6.80012 3.76187L9.74541 6.70719Z"
      fill="var(--icon-arrow-color)"
    />
  </svg>
)
